export default "__VITE_ASSET__1ea1aa29__"